import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { TERMS_OF_SERVICE_AND_PRIVACY_NOTICE } from "../constants/termsOfService";

interface TermsOfServiceDialogProps {
  open: boolean;
  onClose: () => void;
}

export const TermsOfServiceDialog: React.FC<TermsOfServiceDialogProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Terms of Service and Privacy Notice</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
          {TERMS_OF_SERVICE_AND_PRIVACY_NOTICE}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
